export default __webpack_public_path__ + "static/media/icon-star-empty.7a9bab5f.svg";